module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('HeadersDetalhesResumo', {
    attrs: {
      "apelido": _vm.imovel.apelido,
      "proprietario": _vm.imovel.proprietario,
      "tipo": _vm.imovel.tipo
    }
  }), _vm._v(" "), _c('v-layout', {
    staticClass: "secondary white--text detalhes-header",
    attrs: {
      "row": "",
      "wrap": "",
      "align-center": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs2": ""
    }
  }, [_c('v-container', {
    staticClass: "py-2",
    attrs: {
      "fluid": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    staticClass: "text-xs-left",
    attrs: {
      "xs12": ""
    }
  }, [_c('v-btn', {
    staticClass: "ma-0 white--text",
    attrs: {
      "icon": "",
      "to": ({
        name: 'ImoveisDetalhesResumo',
        params: {
          id: _vm.$route.params.id
        }
      })
    }
  }, [_c('v-icon', [_vm._v("close")])], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs8": ""
    }
  }, [_c('v-container', {
    staticClass: "py-2",
    attrs: {
      "fluid": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('span', {
    staticClass: "subtitulo"
  }, [_vm._v("Agendar tarefa")])])], 1)], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs2": ""
    }
  }, [_c('v-container', {
    staticClass: "py-2",
    attrs: {
      "fluid": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-btn', {
    attrs: {
      "flat": "",
      "disabled": _vm.isFormInvalid
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.onSubmit($event)
      }
    }
  }, [_c('span', {
    staticClass: "subtitulo"
  }, [_vm._v("Salvar")])])], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.onSubmit($event)
      }
    }
  }, [_c('v-layout', {
    staticClass: "pt-5",
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm10": "",
      "offset-sm1": "",
      "md8": "",
      "offset-md2": ""
    }
  }, [_c('v-container', {
    staticClass: "px-0",
    attrs: {
      "fluid": ""
    }
  }, [_c('v-layout', {
    staticClass: "ma-0",
    attrs: {
      "wrap": ""
    }
  }, [_c('v-flex', {
    staticClass: "pa-0",
    attrs: {
      "xs12": ""
    }
  }, [_c('v-dialog', {
    attrs: {
      "transition": "dialog-bottom-transition",
      "overlay": false
    },
    on: {
      "input": function($event) {
        _vm.menuData = false
      }
    },
    model: {
      value: (_vm.dialogTarefasTipos),
      callback: function($$v) {
        _vm.dialogTarefasTipos = $$v
      },
      expression: "dialogTarefasTipos"
    }
  }, [_c('v-text-field', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }, {
      name: "show",
      rawName: "v-show",
      value: (!_vm.dialogTarefasTipos),
      expression: "!dialogTarefasTipos"
    }],
    staticClass: "label_fix",
    attrs: {
      "slot": "activator",
      "label": "Tipo de tarefa",
      "name": "tipo",
      "data-vv-as": "tipo",
      "error-messages": _vm.errors.has('tipo') ? _vm.errors.first('tipo') : [],
      "single-line": "",
      "full-width": "",
      "hide-details": "",
      "prepend-icon": "event_available",
      "readonly": ""
    },
    slot: "activator",
    model: {
      value: (_vm.form.fields.tipo),
      callback: function($$v) {
        _vm.form.fields.tipo = $$v
      },
      expression: "form.fields.tipo"
    }
  }), _vm._v(" "), _c('v-card', [_c('v-toolbar', {
    staticClass: "primary",
    attrs: {
      "dark": ""
    }
  }, [_c('v-toolbar-title', [_vm._v("Tarefa")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-toolbar-items', [_c('v-btn', {
    attrs: {
      "dark": "",
      "flat": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.dialogTarefasTipos = false
      }
    }
  }, [_vm._v("Concluir")])], 1)], 1), _vm._v(" "), _c('v-list', [_vm._l((_vm.tarefaTipo), function(item, index) {
    return _c('v-list-tile', {
      key: item.id,
      nativeOn: {
        "click": function($event) {
          _vm.selectTarefa(item)
        }
      }
    }, [_c('v-list-tile-action', [(index === 0) ? _c('v-icon', [_vm._v("event_available")]) : _vm._e()], 1), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v(_vm._s(item))])], 1), _vm._v(" "), (_vm.form.fields.tipo === item) ? _c('v-list-tile-action', [_c('v-icon', {
      staticClass: "secondary--text"
    }, [_vm._v("done")])], 1) : _vm._e()], 1)
  }), _vm._v(" "), _c('v-list-tile', [_c('v-list-tile-action', [(_vm.tarefaTipo.length === 0) ? _c('v-icon', [_vm._v("event_available")]) : _vm._e()], 1), _vm._v(" "), _c('v-list-tile-content', [_c('v-text-field', {
    staticClass: "tarefa_personalizada",
    attrs: {
      "label": "Personalizada",
      "single-line": "",
      "full-width": "",
      "hide-details": ""
    },
    model: {
      value: (_vm.tipoTarefaPersonalizada),
      callback: function($$v) {
        _vm.tipoTarefaPersonalizada = $$v
      },
      expression: "tipoTarefaPersonalizada"
    }
  })], 1), _vm._v(" "), (_vm.tipoTarefaPersonalizada.length > 0 && _vm.tipoTarefaPersonalizada === _vm.form.fields.tipo) ? _c('v-list-tile-action', [_c('v-icon', {
    staticClass: "secondary--text"
  }, [_vm._v("done")])], 1) : _vm._e()], 1)], 2)], 1)], 1)], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "pa-0",
    attrs: {
      "xs12": ""
    }
  }, [_c('v-divider'), _vm._v(" "), _c('v-menu', {
    attrs: {
      "lazy": "",
      "transition": "scale-transition",
      "offset-y": "",
      "full-width": "",
      "nudge-left": 40,
      "max-width": "290px",
      "nudge-top": 140
    },
    model: {
      value: (_vm.menuData),
      callback: function($$v) {
        _vm.menuData = $$v
      },
      expression: "menuData"
    }
  }, [_c('v-text-field', {
    staticClass: "label_fix",
    attrs: {
      "slot": "activator",
      "prepend-icon": "today",
      "label": "Adicionar data",
      "single-line": "",
      "full-width": "",
      "hide-details": "",
      "readonly": ""
    },
    slot: "activator",
    model: {
      value: (_vm.form.fields.data_formatada),
      callback: function($$v) {
        _vm.form.fields.data_formatada = $$v
      },
      expression: "form.fields.data_formatada"
    }
  }), _vm._v(" "), _c('v-date-picker', {
    attrs: {
      "locale": "pt-br",
      "autosave": "",
      "allowed-dates": _vm.datasPermitidas,
      "date-format": function (date) { return new Date(date).toLocaleDateString(); },
      "formatted-value": _vm.form.fields.data_formatada
    },
    on: {
      "update:formattedValue": function($event) {
        _vm.form.fields.data_formatada = $event
      }
    },
    model: {
      value: (_vm.form.fields.data),
      callback: function($$v) {
        _vm.form.fields.data = $$v
      },
      expression: "form.fields.data"
    }
  })], 1)], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "pa-0",
    attrs: {
      "xs12": ""
    }
  }, [_c('v-divider'), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "transition": "dialog-bottom-transition",
      "overlay": false
    },
    on: {
      "input": function($event) {
        _vm.menuData = false
      }
    },
    model: {
      value: (_vm.dialogUsuarios),
      callback: function($$v) {
        _vm.dialogUsuarios = $$v
      },
      expression: "dialogUsuarios"
    }
  }, [_c('v-text-field', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "label_fix",
    attrs: {
      "slot": "activator",
      "label": "Selecionar usuário",
      "name": "usuario",
      "data-vv-as": "usuário",
      "error-messages": _vm.errors.has('usuario') ? _vm.errors.first('usuario') : [],
      "single-line": "",
      "full-width": "",
      "hide-details": "",
      "prepend-icon": "person",
      "readonly": ""
    },
    slot: "activator",
    model: {
      value: (_vm.form.fields.user_name),
      callback: function($$v) {
        _vm.form.fields.user_name = $$v
      },
      expression: "form.fields.user_name"
    }
  }), _vm._v(" "), _c('v-card', [_c('v-toolbar', {
    staticClass: "primary",
    attrs: {
      "dark": ""
    }
  }, [_c('v-toolbar-title', [_vm._v("Usuário")])], 1), _vm._v(" "), _c('v-list', {
    attrs: {
      "two-line": ""
    }
  }, _vm._l((_vm.users), function(item, index) {
    return _c('v-list-tile', {
      key: item.id,
      nativeOn: {
        "click": function($event) {
          _vm.selectUser(item.id)
        }
      }
    }, [_c('v-list-tile-avatar', {
      staticClass: "avatar_sem_borda"
    }, [_c('img', {
      staticClass: "avatar_borda",
      attrs: {
        "src": item.avatar
      }
    })]), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v(_vm._s(item.name))]), _vm._v(" "), _c('v-list-tile-sub-title', [_vm._v(_vm._s(item.cargo))])], 1), _vm._v(" "), (item.id === _vm.form.fields.user_id) ? _c('v-list-tile-action', [_c('v-icon', {
      staticClass: "secondary--text"
    }, [_vm._v("done")])], 1) : _vm._e()], 1)
  }))], 1)], 1), _vm._v(" "), _c('v-divider')], 1)], 1)], 1)], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6ec343ef"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Tarefas/TarefasEditar.vue
// module id = 1025
// module chunks = 1